import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";
import styles from "./ui.module.css";

export interface ActionBarProps extends HTMLAttributes<HTMLDivElement> {
  left?: ReactNode;
  right?: ReactNode;
  children?: ReactNode;
}

export function ActionBar({
  left,
  right,
  children,
  className,
  ...rest
}: ActionBarProps) {
  return (
    <div className={cn(styles.actionBar, className)} {...rest}>
      <div>{left ?? children}</div>
      {right ? <div>{right}</div> : null}
    </div>
  );
}
